<template>
    <div>
        <loading v-show="isLoading"></loading>
        <el-row :gutter="20">
            <el-col :span="24" >
                <el-card class="box-card" :style="'height:'+bodyHeight+'px'">
                    <div slot="header" class="clearfix">
                        <el-button type="primary" size="small" @click="add"  icon="el-icon-plus" plain>添加</el-button>

                        <el-date-picker
                        @change="query"
                        :clearable="false"
                        size="small" 
                        style="width:300px;margin-left:20px"
                        v-model="queryModel.createTimes"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>

                        <el-select size="small" style="margin-left:30px;width:100px"   v-model="queryModel.type" clearable placeholder="类型">
                            <el-option label="线下支出" :value="1"> </el-option>
                            <el-option label="出纳工资" :value="2"> </el-option>
                            <el-option label="审核工资" :value="3"> </el-option>
                            <el-option label="线下收入" :value="4"> </el-option>
                            <el-option label="外放支出" :value="5"> </el-option>
                        </el-select>

                        <el-tooltip class="item" effect="dark" content="查询" placement="top">
                            <el-button type="primary" size="small" style="margin-left:30px;" @click="query" icon="el-icon-search" plain circle></el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="重置" placement="top">
                            <el-button type="primary" size="small" style="margin-left:15px;" @click="reset" icon="el-icon-aim" plain circle></el-button>
                        </el-tooltip>
                        

                        <el-pagination
                        style="float:right"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryModel.pIndex"
                        :page-sizes="[20, 40, 60, 80]"
                        :page-size="queryModel.pSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                    <el-table
                    v-loading="isLoading"
                    :height="bodyHeight-130"
                    :data="tableData"
                    style="width: 100%">
                        <el-table-column
                            prop="Description"
                            label="摘要">
                        </el-table-column>
                        <el-table-column
                            label="类型">
                            <template slot-scope="scope">
                                <el-tag size="mini"   type="danger" v-if="scope.row.Type==1">报销</el-tag>
                                <el-tag size="mini"   type="danger" v-else-if="scope.row.Type==2">兼职出纳工资</el-tag>
                                <el-tag size="mini"   type="danger" v-else-if="scope.row.Type==3">兼职审核工资</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column
                            label="金额">
                            <template slot-scope="scope">
                                    <el-link :type="scope.row.Money>0?'danger':'success'">￥{{scope.row.Money.toFixed(2)}}</el-link>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="CreateTime"
                            label="创建时间">
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog title="添加支出"  :visible.sync="dialogFormVisible" width="700px">
            <el-form :model="newModel"  :rules="rules" ref="ruleForm" label-width="80px">
                <el-form-item label="金额：" prop="Money">
                    <el-input placeholder="请输入支出金额" v-model="newModel.Money"></el-input>
                </el-form-item>
                <el-form-item label="类型：" prop="Type">
                    <el-radio-group v-model="newModel.Type">
                        <el-radio :label="1">线下支出</el-radio>
                        <el-radio :label="2">出纳工资</el-radio>
                        <el-radio :label="3">审核工资</el-radio>
                        <el-radio :label="4">线下收入</el-radio>
                        <el-radio :label="5">外放支出</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注：" prop="Description">
                    <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="请输入内容"
                    v-model="newModel.Description">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { reimbursementGet,reimbursementAdd} from '@/request.js'
import { formatDate } from '@/commonUtil.js'

export default {
    components: {
    },
    props:{

    },
    data(){
        return {
            dialogFormVisible:false,
            total:0,
            bodyHeight:0,
            isLoading:false,
            queryModel:{
                type:"",
                createTimes:[],
                pSize:20,
                pIndex:1,
            },
            newModel:{
                Description:"",
                Money:0,
                Type:0,
            },
            tableData:[],
            rules: {
                Description: [
                    { required: true, message: '请填写支出备注', trigger: 'blur' },
                    { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
                ],
                Money: [
                    { required: true, message: '请填写支出金额', trigger: 'blur' },
                ],
                Type: [
                    { required: true, message: '请选择支出类型', trigger: 'change' }
                ],
            },
        }
    },
    created(){
        this.bodyHeight=document.documentElement.clientHeight-129;
        
    },
    mounted(){
        var date=new Date();
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.queryModel.createTimes.push(new Date(date.getFullYear(),date.getMonth(),date.getDate()));
        this.query();
    },
    methods: {
        close(){
            this.dialogFormVisible = false;
        },
        submitForm(){
            this.$refs["ruleForm"].validate((valid) => {
                if (valid) {
                    reimbursementAdd(this.newModel,(res)=>{
                        if(res.IsSuccess){
                            this.$message({
                                message: '添加成功',
                                type: 'success'
                            });
                            this.dialogFormVisible=false;
                            this.query();
                        }else{
                            this.$message.error(res.Message);
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        add(){
            this.newModel={
                Description:"",
                Money:0,
                Type:1,
            };
            this.dialogFormVisible=true;
        },
        query(){
            this.isLoading=true;
            let arr=[]
            this.queryModel.createTimes.forEach(x=>{
                console.log(x);
                arr.push(formatDate(new Date(x),"yyyy-MM-dd"))
            });
            reimbursementGet({
                pIndex:this.queryModel.pIndex,
                pSize:this.queryModel.pSize,
                outsiderId:this.queryModel.outsiderId==""?0:parseInt(this.queryModel.outsiderId),
                type:this.queryModel.type==""?0:parseInt(this.queryModel.type),
                createTimes:this.queryModel.createTimes==null?"[]":JSON.stringify(arr),
            },(res)=>{
                this.tableData=res.Result;
                this.total=res.TotalCount;
                setTimeout(() => {
                    this.isLoading=false;
                }, 300);
            })
        },
        reset(){
            this.queryModel={
                queryTxt:"",
                type:1,
                createTimes:[],
                pSize:20,
                pIndex:1,
            }
        },
        handleSizeChange(val){
            this.queryModel.pSize=val;
            this.query();
        },
        handleCurrentChange(val){
            this.queryModel.pIndex=val;
            this.query();
        }
    }
}
</script>
<style >
.el-dialog__body{
    padding:10px 20px;
}
</style>